import * as fromNewsletters from './newsletters.reducer';
import { ActionReducerMap, createFeatureSelector, MetaReducer } from '@ngrx/store';
import { environment } from '../../../../environments/environment';

export const featureKey = 'newsletters';

export interface NewslettersModuleState {
  newsletters: fromNewsletters.NewslettersState;
}

export const reducers: ActionReducerMap<NewslettersModuleState> = {
  newsletters: fromNewsletters.NewslettersReducer,
};

export const getNewslettersModuleState = createFeatureSelector<NewslettersModuleState>(featureKey);

export const metaReducers: MetaReducer<NewslettersModuleState>[] = !environment.production ? [] : [];
